import React from "react";
const LoginLayout = ({ children }) => <>{children}</>;
export default LoginLayout;
